import { getExtensionFile } from "./getExtensionFile";

export const isAllowedExtension = (file, allowedExtensions) => {
  const fileExtension = getExtensionFile(file);

  return allowedExtensions.some((allowedExtension) => {
    return fileExtension === allowedExtension;
  });
};
